// --- BEGIN INLINED ERROR MESSAGE LOGIC ---
interface ErrorMessages {
  [errorCode: string]: string; // For translated messages
}

interface HpApiErrorMessages {
  [errorCode: string]: string; // For English labels from backend to match against
}

// English labels from EnumErrorCode.php for matching if backend sends English message
const hpApiErrorMessagesEnglish: HpApiErrorMessages = {
  'HP-AUTH-001': 'Invalid API key',
  'HP-AUTH-002': 'Disabled API key',
  'HP-AUTH-003': 'Expired API key',
  'HP-AUTH-004': 'Disabled merchant',
  'HP-AUTH-005': 'Domain not allowed',
  'HP-AUTH-006': 'Invalid global API key',
  'HP-VAL-100': 'Validation error',
  'HP-VAL-101': 'Required field',
  'HP-VAL-102': 'Invalid field',
  'HP-VAL-103': 'Duplicate field',
  'HP-ORD-201': 'Order not found',
  'HP-ORD-202': 'Invalid order status',
  'HP-ORD-203': 'Order not cancelable',
  'HP-ORD-204': 'Invalid payment method priority',
  'HP-ORD-205': 'Invalid payment method',
  'HP-PSP-301': 'Invalid PSP credentials',
  'HP-PSP-302': 'PSP transaction rejected',
  'HP-PSP-303': 'PSP communication error',
  'HP-HOL-401': 'Invalid unhold request',
  'HP-SYS-901': 'Internal server error',
  'HP-SYS-902': 'Service unavailable',
  'HP-SYS-910': 'Network error',
  'HP-SYS-911': 'Request timeout',
  'HP-SYS-912': 'User offline',
  'HP-SYS-999': 'Too many requests',
};

const errorMessagesEs: ErrorMessages = {
  // --- Hotelpay Generic Codes (HP-XXX) --- Spanish Translations
  'HP-AUTH-001': 'La clave de API proporcionada no es válida o falta. Por favor, verifica tus credenciales.',
  'HP-AUTH-002': 'Esta clave de API ha sido deshabilitada. Contacta a soporte para más información.',
  'HP-AUTH-003': 'La clave de API ha expirado. Por favor, contacta a soporte.',
  'HP-AUTH-004': 'El comercio asociado a esta operación ha sido deshabilitado. Contacta a soporte.',
  'HP-AUTH-005': 'La solicitud proviene de un dominio no autorizado. Verifica la configuración de tu comercio.',
  'HP-AUTH-006': 'La clave de API global proporcionada no es válida.',
  'HP-VAL-100': 'Problema de validación. Uno o más datos ingresados son incorrectos. Por favor, revísalos.',
  'HP-VAL-101': 'Uno o más campos obligatorios no fueron completados. Por favor, verifica el formulario.',
  'HP-VAL-102': 'El valor de uno o más campos no es válido. Por favor, corrige la información.',
  'HP-VAL-103': 'Se encontró un valor duplicado donde se esperaba un valor único. Por favor, verifica los datos.',
  'HP-VAL-104': 'El valor está fuera del rango permitido.',
  'HP-VAL-105': 'La combinación de campos es inválida.',
  'HP-VAL-151': 'El formato de la clave API es inválido.',
  'HP-VAL-152': 'El formato de la referencia es inválido.',
  'HP-VAL-153': 'Esta referencia ya existe para este comercio.',
  'HP-VAL-154': 'La selección de PSP no es válida.',
  'HP-VAL-155': 'La prioridad del método de pago es inválida.',
  'HP-VAL-156': 'El número de tarjeta no es válido.',
  'HP-VAL-157': 'La fecha de expiración de la tarjeta es inválida.',
  'HP-VAL-158': 'El código CVV de la tarjeta es inválido.',
  'HP-VAL-159': 'El formato del email es inválido.',
  'HP-VAL-160': 'El formato del teléfono es inválido.',
  'HP-ORD-201': 'La orden de pago no pudo ser encontrada. Verifica el identificador o intenta crear una nueva.',
  'HP-ORD-202': 'El estado actual de la orden no permite realizar esta operación.',
  'HP-ORD-203': 'Esta orden no puede ser cancelada en su estado actual.',
  'HP-ORD-204': 'La prioridad asignada al método de pago no es válida.',
  'HP-ORD-205': 'El método de pago seleccionado no es válido o no está disponible para esta transacción.',
  'HP-PSP-301': 'Las credenciales para el proveedor de pagos no son válidas. El administrador del comercio debe revisar la configuración.',
  'HP-PSP-302': 'La transacción fue rechazada por el procesador de pagos. Intenta con otro método de pago o contacta a tu banco.',
  'HP-PSP-303': 'Hubo un problema de comunicación con el procesador de pagos. Por favor, intenta nuevamente en unos momentos.',
  'HP-HOL-401': 'La solicitud para liberar los fondos retenidos no es válida o no procede.',
  'HP-SYS-901': 'Ocurrió un inconveniente inesperado en nuestros sistemas. Por favor, intenta nuevamente más tarde. Si el problema persiste, contacta a soporte.',
  'HP-SYS-902': 'El servicio no está disponible temporalmente. Por favor, intenta de nuevo en unos minutos.',
  'HP-SYS-910': 'No se pudo conectar con el servidor. Por favor, verifica tu conexión a internet e intenta nuevamente.',
  'HP-SYS-911': 'La solicitud tardó demasiado en responder. Por favor, verifica tu conexión e intenta nuevamente.',
  'HP-SYS-912': 'No tienes conexión a internet. Por favor, conecta tu dispositivo a una red e intenta nuevamente.',
  'HP-SYS-999': 'Has realizado demasiadas solicitudes en poco tiempo. Por favor, espera un momento y vuelve a intentarlo.',

  // --- PSP Specific Codes (Examples from Openpay) --- Spanish Translations
  '1000': 'Ocurrió un inconveniente interno en el servidor de pagos. Por favor, contacta a soporte.',
  '1001': 'La solicitud al servicio de pagos tiene un formato incorrecto. Por favor, revisa los datos enviados.',
  '1002': 'Problema de autenticación con el servicio de pagos. El administrador del comercio debe revisar la configuración.',
  '1003': 'La operación no se pudo completar porque uno o más parámetros enviados al servicio de pagos son incorrectos.',
  '1004': 'El servicio de pagos no se encuentra disponible en este momento. Por favor, intenta más tarde.',
  '1005': 'El recurso solicitado no existe en el servicio de pagos.',
  '1006': 'Ya existe una transacción con el mismo identificador en el servicio de pagos. Evita duplicar la operación.',
  '1007': 'La transferencia de fondos fue rechazada. Contacta a tu banco o intenta con otra tarjeta.',
  '2004': 'El número de tarjeta no es válido. Por favor, verifica los dígitos e intenta de nuevo.',
  '2005': 'La fecha de expiración de la tarjeta es anterior a la fecha actual. Por favor, usa una tarjeta vigente.',
  '2006': 'El código de seguridad de la tarjeta (CVV2) es requerido. Por favor, ingrésalo para continuar.',
  '2007': 'Estás utilizando una tarjeta de prueba en un ambiente que requiere una tarjeta real. Por favor, usa una tarjeta válida.',
  '2008': 'La tarjeta indicada no es válida para pagos con puntos.',
  '2009': 'El código de seguridad de la tarjeta (CVV2) no es válido. Verifícalo e intenta de nuevo.',
  '3001': 'Tu tarjeta fue declinada por el banco. Por favor, intenta con otra tarjeta o contacta a tu banco para más información.',
  '3002': 'Tu tarjeta ha expirado. Por favor, utiliza una tarjeta vigente.',
  '3003': 'Tu tarjeta no tiene fondos suficientes. Verifica tu saldo o intenta con otra tarjeta.',
  '3004': 'Tu tarjeta ha sido identificada como robada. Se contactará a las autoridades.',
  '3005': 'Tu tarjeta ha sido rechazada por el sistema antifraude. Por favor, contacta a tu banco.',
  'DEFAULT_ERROR': 'Ocurrió un inconveniente inesperado. Por favor, intenta de nuevo. Si el problema persiste, contacta a soporte.'
};

const errorMessagesEn: ErrorMessages = {
  // --- Hotelpay Generic Codes (HP-XXX) --- English Translations (mostly same as hpApiErrorMessagesEnglish but can differ for friendliness)
  'HP-AUTH-001': 'The API key provided is invalid or missing. Please check your credentials.',
  'HP-AUTH-002': 'This API key has been disabled. Contact support for more information.',
  'HP-AUTH-003': 'The API key has expired. Please contact support.',
  'HP-AUTH-004': 'The merchant associated with this operation has been disabled. Contact support.',
  'HP-AUTH-005': 'The request comes from an unauthorized domain. Check your merchant settings.',
  'HP-AUTH-006': 'The global API key provided is invalid.',
  'HP-VAL-100': 'Validation issue. One or more entered data are incorrect. Please review them.',
  'HP-VAL-101': 'One or more required fields were not completed. Please check the form.',
  'HP-VAL-102': 'The value of one or more fields is invalid. Please correct the information.',
  'HP-VAL-103': 'A duplicate value was found where a unique value was expected. Please check the data.',
  'HP-VAL-104': 'The value is out of range.',
  'HP-VAL-105': 'The field combination is invalid.',
  'HP-VAL-151': 'Invalid API key format.',
  'HP-VAL-152': 'Invalid reference format.',
  'HP-VAL-153': 'This reference already exists for this merchant.',
  'HP-VAL-154': 'Invalid PSP selection.',
  'HP-VAL-155': 'Invalid payment method priority.',
  'HP-VAL-156': 'Invalid card number.',
  'HP-VAL-157': 'Invalid card expiry date.',
  'HP-VAL-158': 'Invalid card CVV.',
  'HP-VAL-159': 'Invalid email format.',
  'HP-VAL-160': 'Invalid phone format.',
  'HP-ORD-201': 'The payment order could not be found. Check the identifier or try creating a new one.',
  'HP-ORD-202': 'The current status of the order does not allow this operation.',
  'HP-ORD-203': 'This order cannot be canceled in its current state.',
  'HP-ORD-204': 'The priority assigned to the payment method is invalid.',
  'HP-ORD-205': 'The selected payment method is invalid or not available for this transaction.',
  'HP-PSP-301': 'The credentials for the payment provider are invalid. The merchant administrator should review the configuration.',
  'HP-PSP-302': 'The transaction was rejected by the payment processor. Try another payment method or contact your bank.',
  'HP-PSP-303': 'There was a communication problem with the payment processor. Please try again in a few moments.',
  'HP-HOL-401': 'The request to release the held funds is invalid or does not apply.',
  'HP-SYS-901': 'An unexpected issue occurred in our systems. Please try again later. If the problem persists, contact support.',
  'HP-SYS-902': 'The service is temporarily unavailable. Please try again in a few minutes.',
  'HP-SYS-910': 'Could not connect to the server. Please check your internet connection and try again.',
  'HP-SYS-911': 'The request took too long to respond. Please check your connection and try again.',
  'HP-SYS-912': 'No internet connection. Please connect your device to a network and try again.',
  'HP-SYS-999': 'You have made too many requests in a short time. Please wait a moment and try again.',

  // --- PSP Specific Codes (Examples from Openpay) --- English Translations
  '1000': 'An internal issue occurred on the payment server. Please contact support.',
  '1001': 'The request to the payment service has an incorrect format. Please review the data sent.',
  '1002': 'Authentication issue with the payment service. The merchant administrator should review the configuration.',
  '1003': 'The operation could not be completed because one or more parameters sent to the payment service are incorrect.',
  '1004': 'The payment service is not available at this time. Please try again later.',
  '1005': 'The requested resource does not exist in the payment service.',
  '1006': 'A transaction with the same identifier already exists in the payment service. Avoid duplicating the operation.',
  '1007': 'The fund transfer was rejected. Contact your bank or try another card.',
  '2004': 'The card number is invalid. Please check the digits and try again.',
  '2005': 'The card expiration date is earlier than the current date. Please use a valid card.',
  '2006': 'The card security code (CVV2) is required. Please enter it to continue.',
  '2007': 'You are using a test card in an environment that requires a real card. Please use a valid card.',
  '2008': 'The indicated card is not valid for payments with points.',
  '2009': 'The card security code (CVV2) is invalid. Verify it and try again.',
  '3001': 'Your card was declined by the bank. Please try another card or contact your bank for more information.',
  '3002': 'Your card has expired. Please use a valid card.',
  '3003': 'Your card does not have sufficient funds. Check your balance or try another card.',
  '3004': 'Your card has been identified as stolen. Authorities will be contacted.',
  '3005': 'Your card has been rejected by the anti-fraud system. Please contact your bank.',
  'DEFAULT_ERROR': 'An unexpected issue occurred. Please try again. If the problem persists, contact support.'
};

const errorMessagesFr: ErrorMessages = {
  'HP-AUTH-001': 'La clé API fournie est invalide ou manquante. Veuillez vérifier vos identifiants.',
  'HP-AUTH-002': 'Cette clé API a été désactivée. Contactez le support pour plus d\'informations.',
  'HP-AUTH-003': 'La clé API a expiré. Veuillez contacter le support.',
  'HP-AUTH-004': 'Le marchand associé à cette opération a été désactivé. Contactez le support.',
  'HP-AUTH-005': 'La requête provient d\'un domaine non autorisé. Vérifiez les paramètres de votre marchand.',
  'HP-AUTH-006': 'La clé API globale fournie est invalide.',
  'HP-VAL-100': 'Problème de validation. Une ou plusieurs données saisies sont incorrectes. Veuillez les vérifier.',
  'HP-VAL-101': 'Un ou plusieurs champs obligatoires n\'ont pas été remplis. Veuillez vérifier le formulaire.',
  'HP-VAL-102': 'La valeur d\'un ou plusieurs champs est invalide. Veuillez corriger les informations.',
  'HP-VAL-103': 'Une valeur en double a été trouvée alors qu\'une valeur unique était attendue. Veuillez vérifier les données.',
  'HP-VAL-104': 'La valeur est hors de la plage autorisée.',
  'HP-VAL-105': 'La combinaison de champs est invalide.',
  'HP-VAL-151': 'Format de clé API invalide.',
  'HP-VAL-152': 'Format de référence invalide.',
  'HP-VAL-153': 'Cette référence existe déjà pour ce marchand.',
  'HP-VAL-154': 'Sélection PSP invalide.',
  'HP-VAL-155': 'Priorité du mode de paiement invalide.',
  'HP-VAL-156': 'Numéro de carte invalide.',
  'HP-VAL-157': 'Date d\'expiration de la carte invalide.',
  'HP-VAL-158': 'Code CVV de la carte invalide.',
  'HP-VAL-159': 'Format d\'email invalide.',
  'HP-VAL-160': 'Format de téléphone invalide.',
  'HP-ORD-201': 'L\'ordre de paiement n\'a pas pu être trouvé. Vérifiez l\'identifiant ou essayez d\'en créer un nouveau.',
  'HP-ORD-202': 'L\'état actuel de la commande ne permet pas cette opération.',
  'HP-ORD-203': 'Cette commande ne peut pas être annulée dans son état actuel.',
  'HP-ORD-204': 'La priorité attribuée au mode de paiement est invalide.',
  'HP-ORD-205': 'Le mode de paiement sélectionné est invalide ou non disponible pour cette transaction.',
  'HP-PSP-301': 'Les identifiants du fournisseur de paiement sont invalides. L\'administrateur du marchand doit vérifier la configuration.',
  'HP-PSP-302': 'La transaction a été rejetée par le processeur de paiement. Essayez un autre mode de paiement ou contactez votre banque.',
  'HP-PSP-303': 'Un problème de communication est survenu avec le processeur de paiement. Veuillez réessayer dans quelques instants.',
  'HP-HOL-401': 'La demande de libération des fonds retenus est invalide ou ne s\'applique pas.',
  'HP-SYS-901': 'Un incident inattendu s\'est produit dans nos systèmes. Veuillez réessayer plus tard. Si le problème persiste, contactez le support.',
  'HP-SYS-902': 'Le service est temporairement indisponible. Veuillez réessayer dans quelques minutes.',
  'HP-SYS-910': 'Impossible de se connecter au serveur. Veuillez vérifier votre connexion Internet et réessayer.',
  'HP-SYS-911': 'La demande a mis trop de temps à répondre. Veuillez vérifier votre connexion et réessayer.',
  'HP-SYS-912': 'Pas de connexion Internet. Veuillez connecter votre appareil à un réseau et réessayer.',
  'HP-SYS-999': 'Vous avez effectué trop de requêtes en peu de temps. Veuillez patienter un moment et réessayer.',
  '1000': 'Un incident interne s\'est produit sur le serveur de paiement. Veuillez contacter le support.',
  '1001': 'Le format de la requête adressée au service de paiement est incorrect. Veuillez vérifier les données envoyées.',
  '1002': 'Problème d\'authentification avec le service de paiement. L\'administrateur du marchand doit vérifier la configuration.',
  '1003': 'L\'opération n\'a pas pu être finalisée car un ou plusieurs paramètres envoyés au service de paiement sont incorrects.',
  '1004': 'Le service de paiement n\'est pas disponible pour le moment. Veuillez réessayer plus tard.',
  '1005': 'La ressource demandée n\'existe pas dans le service de paiement.',
  '1006': 'Une transaction avec le même identifiant existe déjà dans le service de paiement. Évitez de dupliquer l\'opération.',
  '1007': 'Le transfert de fonds a été rejeté. Contactez votre banque ou essayez une autre carte.',
  '2004': 'Le numéro de carte est invalide. Veuillez vérifier les chiffres et réessayer.',
  '2005': 'La date d\'expiration de la carte est antérieure à la date actuelle. Veuillez utiliser une carte valide.',
  '2006': 'Le code de sécurité de la carte (CVV2) est requis. Veuillez le saisir pour continuer.',
  '2007': 'Vous utilisez une carte de test dans un environnement qui nécessite une carte réelle. Veuillez utiliser une carte valide.',
  '2008': 'La carte indiquée n\'est pas valide pour les paiements avec points.',
  '2009': 'Le code de sécurité de la carte (CVV2) est invalide. Vérifiez-le et réessayer.',
  '3001': 'Votre carte a été refusée par la banque. Veuillez essayer une autre carte ou contacter votre banque pour plus d\'informations.',
  '3002': 'Votre carte a expiré. Veuillez utiliser une carte valide.',
  '3003': 'Votre carte ne dispose pas de fonds suffisants. Vérifiez votre solde ou essayez une autre carte.',
  '3004': 'Votre carte a été identifiée comme volée. Les autorités seront contactées.',
  '3005': 'Votre carte a été rejetée par le système anti-fraude. Veuillez contacter votre banque.',
  'DEFAULT_ERROR': 'Un incident inattendu s\'est produit. Veuillez réessayer. Si le problème persiste, contactez le support.'
};

const errorMessagesPt: ErrorMessages = {
  'HP-AUTH-001': 'A chave de API fornecida é inválida ou está ausente. Por favor, verifique suas credenciais.',
  'HP-AUTH-002': 'Esta chave de API foi desabilitada. Contate o suporte para mais informações.',
  'HP-AUTH-003': 'A chave de API expirou. Por favor, contate o suporte.',
  'HP-AUTH-004': 'O comerciante associado a esta operação foi desabilitado. Contate o suporte.',
  'HP-AUTH-005': 'A solicitação provém de um domínio não autorizado. Verifique as configurações do seu comerciante.',
  'HP-AUTH-006': 'A chave de API global fornecida é inválida.',
  'HP-VAL-100': 'Problema de validação. Um ou mais dados inseridos estão incorretos. Por favor, revise-os.',
  'HP-VAL-101': 'Um ou mais campos obrigatórios não foram preenchidos. Por favor, verifique o formulário.',
  'HP-VAL-102': 'O valor de um ou mais campos é inválido. Por favor, corrija a informação.',
  'HP-VAL-103': 'Um valor duplicado foi encontrado onde um valor único era esperado. Por favor, verifique os dados.',
  'HP-VAL-104': 'O valor está fora do intervalo permitido.',
  'HP-VAL-105': 'A combinação de campos é inválida.',
  'HP-VAL-151': 'Formato de chave API inválido.',
  'HP-VAL-152': 'Formato de referência inválido.',
  'HP-VAL-153': 'Esta referência já existe para este comerciante.',
  'HP-VAL-154': 'Seleção de PSP inválida.',
  'HP-VAL-155': 'Prioridade do método de pagamento inválida.',
  'HP-VAL-156': 'Número de cartão inválido.',
  'HP-VAL-157': 'Data de validade do cartão inválida.',
  'HP-VAL-158': 'Código CVV do cartão inválido.',
  'HP-VAL-159': 'Formato de email inválido.',
  'HP-VAL-160': 'Formato de telefone inválido.',
  'HP-ORD-201': 'A ordem de pagamento não pôde ser encontrada. Verifique o identificador ou tente criar uma nova.',
  'HP-ORD-202': 'O estado atual do pedido não permite esta operação.',
  'HP-ORD-203': 'Este pedido não pode ser cancelado no seu estado atual.',
  'HP-ORD-204': 'A prioridade atribuída ao método de pagamento é inválida.',
  'HP-ORD-205': 'O método de pagamento selecionado é inválido ou não está disponível para esta transação.',
  'HP-PSP-301': 'As credenciais do provedor de pagamento são inválidas. O administrador do comerciante deve revisar a configuração.',
  'HP-PSP-302': 'A transação foi rejeitada pelo processador de pagamentos. Tente outro método de pagamento ou contate seu banco.',
  'HP-PSP-303': 'Houve um problema de comunicação com o processador de pagamentos. Por favor, tente novamente em alguns instantes.',
  'HP-HOL-401': 'A solicitação para liberar os fundos retidos é inválida ou não se aplica.',
  'HP-SYS-901': 'Ocorreu um incidente inesperado em nossos sistemas. Por favor, tente novamente mais tarde. Se o problema persistir, contate o suporte.',
  'HP-SYS-902': 'O serviço está temporariamente indisponível. Por favor, tente novamente em alguns minutos.',
  'HP-SYS-910': 'Não foi possível conectar ao servidor. Por favor, verifique sua conexão com a internet e tente novamente.',
  'HP-SYS-911': 'A solicitação demorou muito para responder. Por favor, verifique sua conexão e tente novamente.',
  'HP-SYS-912': 'Sem conexão com a internet. Por favor, conecte seu dispositivo a uma rede e tente novamente.',
  'HP-SYS-999': 'Você fez muitas solicitações em pouco tempo. Por favor, aguarde um momento e tente novamente.',
  '1000': 'Ocorreu um incidente interno no servidor de pagamentos. Por favor, contate o suporte.',
  '1001': 'A solicitação ao serviço de pagamentos tem um formato incorreto. Por favor, revise os dados enviados.',
  '1002': 'Problema de autenticação com o serviço de pagamentos. O administrador do comerciante deve revisar a configuração.',
  '1003': 'A operação não pôde ser concluída porque um ou mais parâmetros enviados ao serviço de pagamentos estão incorretos.',
  '1004': 'O serviço de pagamentos não está disponível no momento. Por favor, tente novamente mais tarde.',
  '1005': 'O recurso solicitado não existe no serviço de pagamentos.',
  '1006': 'Já existe uma transação com o mesmo identificador no serviço de pagamentos. Evite duplicar a operação.',
  '1007': 'A transferência de fundos foi rejeitada. Contate seu banco ou tente outro cartão.',
  '2004': 'O número do cartão é inválido. Por favor, verifique os dígitos e tente novamente.',
  '2005': 'A data de validade do cartão é anterior à data atual. Por favor, use um cartão válido.',
  '2006': 'O código de segurança do cartão (CVV2) é obrigatório. Por favor, insira-o para continuar.',
  '2007': 'Você está usando um cartão de teste em um ambiente que requer um cartão real. Por favor, use um cartão válido.',
  '2008': 'O cartão indicado não é válido para pagamentos com pontos.',
  '2009': 'O código de segurança do cartão (CVV2) é inválido. Verifique-o e tente novamente.',
  '3001': 'Seu cartão foi recusado pelo banco. Por favor, tente outro cartão ou contate seu banco para mais informações.',
  '3002': 'Seu cartão expirou. Por favor, utilize um cartão válido.',
  '3003': 'Seu cartão não tem fundos suficientes. Verifique seu saldo ou tente outro cartão.',
  '3004': 'Seu cartão foi identificado como roubado. As autoridades serão contatadas.',
  '3005': 'Seu cartão foi rejeitado pelo sistema antifraude. Por favor, contate seu banco.',
  'DEFAULT_ERROR': 'Ocorreu um incidente inesperado. Por favor, tente novamente. Se o problema persistir, contate o suporte.'
};

export function getFriendlyErrorMessage(
  errorCode?: string | number,
  originalMessage?: string | null,
  language: string = 'es' // Default to Spanish
): string {
  let messages: ErrorMessages;

  // Normalize language codes: 'en-US' -> 'en', 'es-MX' -> 'es', etc.
  const baseLanguage = language.split('-')[0].toLowerCase();

  switch (baseLanguage) {
    case 'es':
      messages = errorMessagesEs;
      break;
    case 'en':
      messages = errorMessagesEn;
      break;
    case 'fr': // Now using 'fr' for French (Canada)
      messages = errorMessagesFr;
      break;
    case 'pt': // Now using 'pt' for Portuguese (Brazil)
      messages = errorMessagesPt;
      break;
    default: // Fallback to Spanish if language not supported, then English for DEFAULT_ERROR
      messages = errorMessagesEs;
  }

  const codeStr = errorCode?.toString();
  const englishDefaultFallback = errorMessagesEn['DEFAULT_ERROR'] || 'An unexpected error occurred. Please try again. If the problem persists, contact support.';
  const selectedLangDefaultFallback = messages['DEFAULT_ERROR'] || englishDefaultFallback;

  // 1. Direct match by error code in the selected language
  if (codeStr && messages[codeStr]) {
    return messages[codeStr];
  }

  // 2. If originalMessage is an English label from hpApiErrorMessagesEnglish, find its code and translate
  if (originalMessage) {
    const matchedHpCode = Object.keys(hpApiErrorMessagesEnglish).find(
      key => hpApiErrorMessagesEnglish[key] === originalMessage
    );
    if (matchedHpCode && messages[matchedHpCode]) {
      return messages[matchedHpCode];
    }
  }
  
  // 3. If originalMessage is a reasonably descriptive message itself (and not a code or short technical string)
  if (originalMessage && originalMessage.length > 10 && originalMessage.includes(' ')) {
    return originalMessage; 
  }

  // 4. Fallback to default error message in the selected language, or English if not found
  return selectedLangDefaultFallback;
}

// --- END INLINED ERROR MESSAGE LOGIC ---
